<template>
	<div>
		<div class="modal-body">
			<div class="d-flex align-items-center justify-content-between">
				<p v-if="currentcheckNumber" class="mb-3 mt-3">№: {{ currentcheckNumber }}</p>
				<b-spinner v-if="saleReturnLoading" variant="primary" class="mb-2" label="Small Spinner"></b-spinner>
			</div>
			<div class="row">
				<b-col cols="12">
					<b-input-group>
						<b-input-group-text slot="prepend">
							<span class="input-group-addon">
								<i class="fa fa-barcode"></i>
							</span>
						</b-input-group-text>
						<b-form-input class="form-control mousetrap ui-autocomplete-input" v-model="inputSearchReturn" id="search_product" ref="saleSearch" :placeholder="mode == 'retail' ? 'Чек №:' : 'Чек № / Артикул / Штрих-код'" @input="filterChanged($event)" @keyup.enter="filterChanged($event)" autocomplete="off" name="search_product" type="text"/>
					</b-input-group>
					<div v-if="loading" class="spinner-wrapper text-center">
						<b-spinner variant="primary"/>
					</div>
					<div id="searchResultRetun" ref="searchResultRetun" v-click-outside="hideSearchResult" :style="[getItems.length > 0 ? { 'min-height': 'unset' } : {}]">
						<with-keyboard-control-for-pos :listLength="getItems.length" @selected="selectedHandler" ref="withKeyboardControl">
							<template slot-scope="{ selectedIndex }">
								<loading v-if="searchLoading" width="60px" height="60px"/>
								<div v-for="(item, index) in getItems" class="d-flex justify-content-between foundProduct align-items-center" :key="'searchItem' + index" @click="selectedHandler(index)">
									<template>
										<div class="productName mb-0 d-flex">
											<div>{{ index + 1 }}.</div>
										</div>
									</template>
									<template>
										<div class="productName mb-0 d-flex">
											<div>{{ item.saleNumber }}</div>
										</div>
									</template>
									<template>
										<div class="productName mb-0 d-flex">
											<div>
												<strong>{{ $t("pos.date") }}:</strong>
												<span>{{ item.saleDate }}</span>
											</div>
										</div>
									</template>
									<template>
										<div class="productName mb-0 d-flex">
											<div>
												<strong>{{$t("sidebar.sales.contragent")}}:</strong>
												<span>{{item.contragentName}}</span>
											</div>
										</div>
									</template>
								</div>
								<p v-if="getItems.length == 0 && !searchLoading" style="padding: 10px;">{{ $t("warehouse.document.saleNotFound") }}</p>
							</template>
						</with-keyboard-control-for-pos>
					</div>
				</b-col>
			</div>
			<table class="table table-bordered mt-3 generalTableClass">
				<thead>
					<tr>
						<th style="width: 30px;text-align: center">№</th>
						<th>{{ $t("sidebar.warehouse-management.products") }}</th>
						<th style="width: 13%">{{ $t("incomes.create.price") }}</th>
						<th>{{ $t("goods.amount") }}</th>
					</tr>
				</thead>
				<tbody v-if="productItems && productItems.length>0">
					<tr v-for="(tmp1, index) in productItems" :key="`items1-${index}`">
						<td class="text-center">{{ index + 1 }}</td>
						<td class="text-left pl-2">{{ tmp1.name }} / <b>{{ tmp1.barcode }}</b></td>
						<td class="text-center">{{tmp1.priceUzs | currency({symbol: userDepCurrencyName,fractionCount: 2,symbolPosition: 'back'})}}</td>
						<td class="text-center">{{ tmp1.count }}</td>
					</tr>
				</tbody>
				<tbody v-if="itemFromSelectedCheck && itemFromSelectedCheck.length>0">
				<tr v-for="(calculateCount, index) in itemFromSelectedCheck" :key="`tmp-${index}`">
					<td class="text-center">{{((documentObject && documentObject.productItems && documentObject.productItems.length > 0) ? documentObject.productItems.length : 0) + index + 1}}</td>
					<td class="text-left pl-2">{{ calculateCount.name }} / <strong>{{ calculateCount.artikul }}</strong> / {{ calculateCount.color }} / {{ calculateCount.size }}<strong>{{calculateCount.barcode }}</strong></td>
					<td class="text-center">{{ calculateCount.priceAfterUzs | currency({symbol: userDepCurrencyName,fractionCount: 2,symbolPosition: "back"}) }}</td>
					<td class="text-center">{{ calculateCount.count }}</td>
				</tr>
				</tbody>
			</table>

			<b-modal v-model="confirmReturn" @ok="sendDataToServer" @cancel="confirmReturn = !confirmReturn" ok-title="Да" cancel-title="Отмена">
				<h4>{{ $t("confirm_returns") }}</h4>
			</b-modal>
			<hr/>
			<div class="row top mt-3 justify-content-end">
				<div class="col-3">
					<b-button variant="outline-danger" size="sm" block @click="close">{{ $t("actions.cancel") }}</b-button>
				</div>
				<div class="col-3">
					<b-button variant="outline-success" size="sm" block @click="confirmReturnModal" :disabled="invalidInputValue">{{ $t("pos.return") }}</b-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import WithKeyboardControlForPos from "../warehouse-management/wholesale/components/WithKeyboardControlForPos";
import Loading from "../components/Loading";
import WholeSaleReportService from "../../services/wholesale.report.service";
import PosReportService from "../../services/pos.report.service";
import ApiService from "@/services/api.service";
import FBoxService from "@/services/fbox.service"
import {mapState} from "vuex";
import Vue from "vue";
import CurrencyService from "@/services/currency.service";

export default {
	name: "ReturnComponent",
	props: {
		mode: {
			type: String,
			default: null
		},
		showReturnModal: {
			type: Boolean,
			default: false
		},

	},
	components: {
		WithKeyboardControlForPos,
		Loading
	},
	data() {
		return {
			lastCurrencyRates: [],
			saleReturnLoading: false,
			inputSearchReturn: "",
			getItems: [],
			searchLoading: false,
			selectedIndex: 0,
			itemFromSelectedCheck: [],
			productItems: [],
			currentcheckNumber: "",
			loading: false,
			isCheckAll: false,
			currentIndex: 0,
			invalidInputValue: false,
			documentObject: {},
			confirmReturn: false,
			currentReturnItemIndex: null
		};
	},
	computed: {
		...mapState(["userDepCurrencyName"])
	},
	methods: {
		confirmReturnModal() {
			if (this.itemFromSelectedCheck.length !== 0 || this.productItems.length !== 0) {
				this.confirmReturn = true;
			} else {
				this.$vs.notify({
					title: "Количество",
					text: "Проверьте количество товаров!",
					color: "danger",
					icon: "close",
					position: "top-right"
				});
			}
		},
		async selectedHandler(index) {
			this.hideSearchResult();
			if (this.getItems[index]) {
				this.currentcheckNumber = this.getItems[index].saleNumber;
			}
			this.loading = true;
			let id = this.getItems[index] ? this.getItems[index].id : null;
			this.itemFromSelectedCheck = [];
			if (id) {
				await PosReportService.getSaleBySaleId(id).then(response => {
					this.documentObject = response.data;
					this.itemFromSelectedCheck = response.data.saleItems ? response.data.saleItems : [];
					this.productItems = response.data.productItems ? response.data.productItems : [];
					this.itemFromSelectedCheck.forEach((item, index) => {
						this.itemFromSelectedCheck[index].returnCount = parseInt(this.itemFromSelectedCheck[index].count);
						this.itemFromSelectedCheck[index].checked = true;
					});
				}).catch(e => {
					this.documentObject = {};
					this.itemFromSelectedCheck = [];
				});
			}
			this.loading = false;
		},
		async sendDataToServer() {
			if (this.itemFromSelectedCheck.length !== 0 || this.productItems.length !== 0) {
				this.saleReturnLoading = true;
				let hasReturnCountError = false
				try {
					let array = JSON.parse(
						JSON.stringify(this.itemFromSelectedCheck)
					);
					array.forEach((item, index) => {
						if (
							array[index].returnCount <= 0 ||
							array[index].returnCount.toString().trim() == ""
						) {
							hasReturnCountError = true;
							let foundIndex = this.itemFromSelectedCheck.findIndex(
								el => el.id == item.id
							);
							if (foundIndex > -1) {
								Vue.set(
									this.itemFromSelectedCheck[foundIndex],
									"_rowVariant",
									"danger"
								);
							}
						} else {
							array[index].count = parseInt(this.itemFromSelectedCheck[index].returnCount);
							delete array[index].returnCount;
							let foundIndex = this.itemFromSelectedCheck.findIndex(
								el => el.id == item.id
							);
							if (foundIndex > -1) {
								if (
									this.itemFromSelectedCheck[foundIndex]
										._rowVariant
								) {
									delete this.itemFromSelectedCheck[foundIndex]
										._rowVariant;
								}
							}
						}
					});
					if (hasReturnCountError) {
						this.$vs.notify({
							title: "Количество",
							text: "Проверьте количество товаров!",
							color: "danger",
							icon: "close",
							position: "top-right"
						});
						return 0;
					}
					this.documentObject.saleItems = array;
					this.documentObject.flight = this.documentObject.flight1
					this.documentObject.ticket = this.documentObject.ticket1
					let msgInError = null
					let type = localStorage.getItem('document_type')
					if (type && type==1) {
						await this.finishReturn({received_cash: null}, {qr_url: null, receipt_count: null, terminal_id: null});
					} else if (type && type==2) {
						await ApiService.post("sale/get/soliq/order-refuse", this.documentObject).then(res => {
							msgInError = res.data
						}).catch(e => {
							let response = JSON.parse(e.request.response);
							try {
								msgInError = JSON.parse(response.message);
							} catch (error) {
								// CHECKED RETURN PAYLOAD FOR SOLIQ FROM SYSTEM
								msgInError = response.message
							}
						});
						if (msgInError.fiscalServiceCheckObject) {
							let resFromFBox = null;
							let errMsgFromFBox = null;
							try {
								// RETURN FOR SOLIQ
								resFromFBox = await FBoxService.orderRefuse(
									localStorage.getItem('ip_address'),
									msgInError
								);
							} catch (e) {
								if (e.request && e.request.response) {
									let response = JSON.parse(e.request.response);
									errMsgFromFBox = response.message;
								}
							}
							if (resFromFBox && resFromFBox.data.is_success) {
								// RETURN IN SYSTEM
								await this.finishReturn(msgInError, resFromFBox.data.data);
							} else {
								this.saleReturnLoading = false
								let fbError = resFromFBox
									? resFromFBox.data.error.message
									: errMsgFromFBox
										? errMsgFromFBox
										: "ERROR: Please, try again";

								this.$vs.notify({
									title: "Xatolik",
									text: fbError,
									color: "danger",
									icon: "close",
									position: "top-right"
								});
							}
						} else {
							this.saleReturnLoading = false
							this.$vs.notify({
								title: "Xatolik",
								text: msgInError,
								color: "danger",
								icon: "close",
								position: "top-right"
							});
						}
					}
				} catch (error) {
					this.saleReturnLoading = false
					this.$vs.notify({
						title: "Xatolik",
						text: error,
						color: "danger",
						icon: "close",
						position: "top-right"
					});
				}
			}
		},
		compareInputValue(event, count, index) {
			this.currentReturnItemIndex = index;
			if (event > count) {
				this.$vs.notify({
					title: "Количество",
					text: "Проверьте количество товаров!",
					color: "danger",
					icon: "close",
					position: "top-right"
				});
				this.invalidInputValue = true;
			} else {
				this.invalidInputValue = false;
			}
		},
		checkAll() {
			this.isCheckAll = !this.isCheckAll;

			if (this.isCheckAll) {
				this.itemFromSelectedCheck.forEach((el, index) => {
					this.itemFromSelectedCheck[index].checked = true;
				});
			} else {
				this.itemFromSelectedCheck.forEach((el, index) => {
					this.itemFromSelectedCheck[index].checked = false;
				});
			}
		},
		escapeClicked() {
		},
		computedCurrentIndex() {
			return this.currentIndex;
		},
		close() {
			this.hideSearchResult();
			this.invalidInputValue = false;
			this.itemFromSelectedCheck = [];
			this.productItems = [];
			this.inputSearchReturn = "";
			this.currentcheckNumber = "";
			this.$emit("close");
		},
		hideSearchResult() {
			if (this.$refs.withKeyboardControl) {
				this.$refs.withKeyboardControl.removeKeyHandler();
			}
			if (this.$refs.searchResultRetun) {
				this.$refs.searchResultRetun.style.display = "none";
			}
		},
		showSearchResult() {
			this.currentIndex = 0;
			if (this.$refs.withKeyboardControl) {
				this.$refs.withKeyboardControl.addKeyHandler();
			}
			this.$refs.searchResultRetun.style.display = "block";
		},
		async filterChanged(newVal) {
			let searchKeyword = typeof newVal == 'string' ? newVal : (typeof newVal == 'object' ? newVal.target.value : '')
			if (searchKeyword.length > 2) {
				this.getItems = []
				this.searchLoading = true;
				switch (this.mode) {
					case "retail":
						this.getItemsRetail(searchKeyword);
						break;
					default:
						this.getItemsWholesale(searchKeyword);
				}
				await this.showSearchResult();
			} else {
				this.hideSearchResult();
			}
		},
		async getItemsRetail(keywords) {
			await PosReportService.getCheckByKeyword(localStorage.getItem('dep_id'), keywords).then(response => {
				this.getItems = response.data;
				this.searchLoading = false;
			});
		},
		async getItemsWholesale(keywords) {
			await WholeSaleReportService.getCheckByKeyword(keywords).then(response => {
				this.getItems = response.data;
				this.searchLoading = false;
			});
		},
		async finishReturn(orderRefuse, fiscal) {
			this.searchLoading = true;
			switch (this.mode) {
				case "retail":
					this.documentObject.qr_url = fiscal.qr_url
					this.documentObject.receipt_count = fiscal.receipt_count
					this.documentObject.terminal_id = fiscal.terminal_id
					this.documentObject.received_cash = orderRefuse.received_cash
					await PosReportService.finishReturn(this.documentObject).then(response => {
						this.saleReturnLoading = false
						this.searchLoading = false;
						this.close();
						this.$vs.notify({
							time: 1000,
							title: "Выполнена успешно!",
							color: "success",
							icon: "close",
							position: "top-right"
						});
					}).catch(e => {
						this.saleReturnLoading = false
						let error = JSON.parse(e.request.response);
						this.$vs.notify({
							text: error.message,
							color: "danger",
							icon: "close",
							position: "top-right"
						});
					});
					break;
				default:
					await WholeSaleReportService.finishReturn(this.documentObject).then(response => {
						this.saleReturnLoading = false
						this.searchLoading = false;
					}).catch(e => {
						this.saleReturnLoading = false
						let error = JSON.parse(e.request.response);
						this.$vs.notify({
							text: error.message,
							color: "danger",
							icon: "close",
							position: "top-right"
						});
					});
			}
		}
	},

	async created() {
		CurrencyService.fetchLastCurrencyRate()
			.then(res => {
				this.lastCurrencyRates = res.data
			})
			.catch(er => {
				console.log(er)
			})
	},

	// WATCHERS
	watch: {
		showReturnModal: {
			handler(newVal) {
				if (newVal) {
					setTimeout(() => {
						this.$refs.saleSearch.focus();
					}, 200);
				}
			}
		},
		itemFromSelectedCheck: {
			handler(newVal) {
				if (this.currentReturnItemIndex && newVal.length > 0) {
					if (
						newVal[this.currentReturnItemIndex].count -
						newVal[this.currentReturnItemIndex].linkedSum <
						newVal[this.currentReturnItemIndex].returnCount
					) {
						// IF RETURN COUNT IS BIGGER THAN POSSIBLE VALUE THEN SET IT TO MAX POSSIBLE VALUE
						Vue.set(
							newVal[this.currentReturnItemIndex],
							"returnCount",
							newVal[this.currentReturnItemIndex].count -
							newVal[this.currentReturnItemIndex].linkedSum
						);
					}
				}
			},
			deep: true
		}
	}
};
</script>
<style scoped lang="scss">
.container {
	padding: 0;
}

// @import url("https://fonts.googleapis.com/css?family=Inconsolata");

#searchResultRetun {
	display: none;
	position: absolute;
	top: 100%;
	width: 92.25%;
	border: 1px solid #c5c5c5;
	left: 4.05%;
	background: #ffffff;
	z-index: 101;
	max-height: 29rem;
	min-height: 80px;
	overflow-x: auto;

	.posItemImage {
		width: 40px;
		height: auto;
		object-fit: cover;
		margin: 0 10px 0 5px;
	}

	.foundProduct {
		padding: 10px;
		cursor: pointer;

		&:hover {
			background: #ccc;
		}

		.productName {
			font-size: 12px;
		}

		.productPrice {
			font-size: 13px;
			width: 32%;
		}

		.productBreadcrumb {
			font-size: 12px;
			color: #888;
		}
	}
}
</style>
